/** Prioridad del servicio (planilla / operación). */
export enum ServicePriority {
  NORMAL = "NORMAL",
  VIP = "VIP",
}

// 🔹 Tipos de servicio
export enum ServiceType {
  DESTINO_DOMICILIOS = "DESTINO_DOMICILIOS",
  ORIGEN_DOMICILIOS = "ORIGEN_DOMICILIOS",
  MANUAL = "MANUAL",
}

// 🔹 Estados del servicio
export enum ServiceStatus {
  PREPARACION = "PREPARACION",
  PROGRAMADO = "PROGRAMADO", // mantiene compatibilidad frontend
  AUTORIZADO = "AUTORIZADO",
  ASIGNADO = "ASIGNADO",
  EN_CURSO = "EN_CURSO",
  COMPLETADO = "COMPLETADO",
  CANCELADO = "CANCELADO",   // mantiene compatibilidad frontend
  ANULADO = "ANULADO",
}